import React, { useEffect, useState } from "react";
import Tag from "./Tag";

const MultiSelectWithCheckbox = (props) => {

    const [searchedList, setSearchedList] = useState(props.list)
    const [search, setSearch] = useState("")

    useEffect(() => {
        const filtered = props.list?.filter((item) => {
            const itemName = item?.name?.toLowerCase?.() || '';
            const searchTerm = search?.toLowerCase?.() || '';
            return itemName.includes(searchTerm);
        });
        setSearchedList(filtered || []);
    }, [search])

    return (
        <div className="NewStrategyModalOverlay">
            <div className="TagChooseModal">
                <div className={ "w-full flex justify-between" }>
                    <div className={ "NewStrategy" }>
                        Tags
                    </div>
                    <button className={ "CloseIconButton" } onClick={ props.close }>
                        <img alt={ "Logo" } src={ "/media/icons/closeIcon.svg" } className={ "w-5 h-5" }/>
                    </button>
                </div>
                <div className={ "HorizontalDivider" }></div>
                <div className="relative flex items-center w-full">
                    <span className="absolute left-3">
                            <img alt={ "Logo" } src={ "/media/icons/searchIcon.svg" }
                                 className={ "h-[17px] w-[17px]" }/>
                    </span>
                    <input type="text" placeholder="Search"
                           className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg outline-none w-full h-9 text-[12px]"
                           onChange={ (e) => setSearch(e.target.value) }
                    />
                </div>
                <div className={ "flex flex-col gap-2 w-full" }>
                    { searchedList?.map((item) =>
                        <div>
                            <Tag tag={ item } chosenLists={ props.selectedItem }
                                 handleChooseList={ props.handleChooseList }></Tag>
                            <div className={ "HorizontalDivider" }></div>
                        </div>
                    ) }
                </div>
                <div className="flex justify-between items-center w-full">
                    <button className={ "SecondaryButton" } onClick={ props.close }>
                        <img alt={ "Logo" } src={ "/media/icons/arrowLeft.svg" } className={ "w-4 h-4" }/>
                        Back
                    </button>
                    <div className="modal-actions">
                        <button type="button" onClick={ props.close } className="CloseButton">
                            Close
                        </button>
                        <button type="submit" className="CreateButton" onClick={ props.close }>
                            Select
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default MultiSelectWithCheckbox;